import classNames from 'classnames'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { QuestionIcon } from '../icons/icon'

export default function Content({
  children,
  surveyErrorMessage,
  surveyIsError,
  surveyParticipated,
  surveyIsPending,
}: {
  children: React.ReactNode
  surveyErrorMessage?: string
  surveyIsError: boolean
  surveyParticipated: boolean
  surveyIsPending: boolean
}) {
  const navigate = useNavigate()

  const handleClickSurvey = () => {
    console.log('설문 진행 클릭')

    navigate('/intro-survey')
  }

  return (
    <>
      {(surveyIsPending || surveyIsError || !surveyParticipated) && (
        <SurveyParticipationBanner
          errorMessage={surveyErrorMessage}
          hasError={surveyIsError}
          hideContent={surveyIsPending}
          onClickTrySurvey={handleClickSurvey}
        />
      )}
      {children}
    </>
  )
}

function SurveyParticipationBanner({
  errorMessage,
  hasError,
  hideContent,
  onClickTrySurvey,
}: {
  errorMessage?: string
  hasError: boolean
  hideContent: boolean
  onClickTrySurvey: () => void
}) {
  const shouldShowSurveyPrompt = !hideContent && !hasError

  return (
    <>
      <div className='relative z-10'>
        <div
          className='absolute w-full bg-white opacity-80'
          style={{ height: 'calc(100vh + 93px)' }}
        ></div>
      </div>
      <div>
        <div className='z-10 absolute flex flex-col items-center w-full justify-center gap-[25px] mt-[50px] tablet-sm:mt-[90px]'>
          <div className={classNames(hideContent && 'survey-loading-icon-bounce')}>
            <QuestionIcon />
          </div>
          {hasError && (
            <div className='font-regular mt-[10px] w-[234px] text-center text-[14px] leading-7 text-text-black-primary tablet-sm:w-[370px] tablet-sm:text-[16px]'>
              <p>설문 정보를 불러오지 못했어요.</p>
              <p className='text-text-black-secondary'>
                {errorMessage ?? '잠시 후 다시 시도해 주세요.'}
              </p>
            </div>
          )}
          {shouldShowSurveyPrompt && (
            <>
              <div className='font-regular text-text-black-primary mt-[10px] text-center w-[234px] tablet-sm:w-[370px] text-pretty leading-7 text-[14px] tablet-sm:text-[16px]'>
                <p>
                  다른 사람은{' '}
                  <span className='whitespace-pre tablet-sm:whitespace-normal'>
                    어떤 도서로 공부하고있을까?
                  </span>
                </p>
                <p>설문에 참여하시면, 스콘이 알려드릴게요.</p>
              </div>
              <button
                className='text-white text-[14px] bg-button-primary-blue rounded-lg w-[206px] h-[40px]'
                onClick={onClickTrySurvey}
              >
                설문 참여하기
              </button>
            </>
          )}
        </div>
      </div>
    </>
  )
}
